<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "whatsapp-groups",
  components: { Breadcrumb, Dialog, InputText },
  data() {
    return {
      breadcrumbs: [
        { name: 'الرئيسية', path: '/' },
        { name: 'مجموعات واتساب', path: '/whatsapp_groups' },
      ],
      loading: false,
      years: [],

      // Create Group modal
      showCreate: false,
      createTarget: null,   // { academic_year_id, year_title, students_count }
      createName: '',
      creating: false,

      // Link / Change Group modal (shared, mode toggled by linkTarget.is_change)
      showLink: false,
      linkTarget: null,
      availableGroups: [],
      selectedAvailable: null,
      loadingAvailable: false,
      linking: false,

      // Send Message modal
      showSend: false,
      sendTarget: null,     // full row object
      sendMessage: '',
      sending: false,
    };
  },
  methods: {
    async fetchYears() {
      this.loading = true;
      try {
        const res = await axios.get('/whatsapp/groups');
        this.years = res.data.data || [];
      } catch {
        Swal.fire({ icon: 'error', title: 'خطأ', text: 'فشل تحميل البيانات', timer: 2000, showConfirmButton: false });
      } finally {
        this.loading = false;
      }
    },

    // ── Create ────────────────────────────────────────────────────────────────
    openCreate(row) {
      this.createTarget = row;
      this.createName = '';
      this.showCreate = true;
    },
    async submitCreate() {
      if (!this.createName.trim()) {
        Swal.fire({ icon: 'warning', title: 'تنبيه', text: 'يرجى إدخال اسم المجموعة' });
        return;
      }
      this.creating = true;
      try {
        const res = await axios.post('/whatsapp/groups/create', {
          academic_year_id: this.createTarget.academic_year_id,
          group_name: this.createName,
        });
        if (res.data.status) {
          this.showCreate = false;
          Swal.fire({ icon: 'success', title: 'تم', text: 'تم إنشاء المجموعة بنجاح', timer: 1500, showConfirmButton: false });
          await this.fetchYears();
        } else {
          Swal.fire({ icon: 'error', title: 'خطأ', text: res.data.message || 'فشل إنشاء المجموعة' });
        }
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'خطأ', text: e.response?.data?.message || 'حدث خطأ غير متوقع' });
      } finally {
        this.creating = false;
      }
    },

    // ── Link / Change ─────────────────────────────────────────────────────────
    async openLink(row, isChange = false) {
      this.linkTarget = {
        academic_year_id: row.academic_year_id,
        year_title: row.year_title,
        existing_id: isChange && row.group ? row.group.id : null,
        is_change: isChange,
      };
      this.selectedAvailable = null;
      this.availableGroups = [];
      this.showLink = true;
      this.loadingAvailable = true;
      try {
        const res = await axios.get('/whatsapp/groups/available');
        const raw = res.data?.data ?? res.data?.groups ?? res.data ?? [];
        this.availableGroups = Array.isArray(raw) ? raw : [];
      } catch {
        Swal.fire({ icon: 'error', title: 'خطأ', text: 'فشل تحميل المجموعات المتاحة' });
        this.showLink = false;
      } finally {
        this.loadingAvailable = false;
      }
    },
    async submitLink() {
      if (!this.selectedAvailable) {
        Swal.fire({ icon: 'warning', title: 'تنبيه', text: 'يرجى اختيار مجموعة من القائمة' });
        return;
      }
      this.linking = true;
      try {
        const jid   = this.selectedAvailable.jid   ?? this.selectedAvailable.id   ?? this.selectedAvailable.gid   ?? '';
        const name  = this.selectedAvailable.name  ?? this.selectedAvailable.subject ?? 'مجموعة';
        const count = this.selectedAvailable.participantsCount ?? this.selectedAvailable.participants_count ?? 0;

        let res;
        if (this.linkTarget.is_change && this.linkTarget.existing_id) {
          res = await axios.post(`/whatsapp/groups/${this.linkTarget.existing_id}/change`, {
            group_jid: jid, group_name: name, participants_count: count,
          });
        } else {
          res = await axios.post('/whatsapp/groups/link', {
            academic_year_id: this.linkTarget.academic_year_id,
            group_jid: jid, group_name: name, participants_count: count,
          });
        }

        if (res.data.status) {
          this.showLink = false;
          const msg = this.linkTarget.is_change ? 'تم تغيير المجموعة بنجاح' : 'تم ربط المجموعة بنجاح';
          Swal.fire({ icon: 'success', title: 'تم', text: msg, timer: 1500, showConfirmButton: false });
          await this.fetchYears();
        } else {
          Swal.fire({ icon: 'error', title: 'خطأ', text: res.data.message || 'فشلت العملية' });
        }
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'خطأ', text: e.response?.data?.message || 'حدث خطأ غير متوقع' });
      } finally {
        this.linking = false;
      }
    },

    // ── Unlink ────────────────────────────────────────────────────────────────
    async unlinkGroup(row) {
      const result = await Swal.fire({
        title: 'إلغاء ربط المجموعة',
        html: `سيتم إلغاء ربط <b>${row.group.group_name}</b> عن <b>${row.year_title}</b>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'نعم، إلغاء الربط',
        cancelButtonText: 'رجوع',
      });
      if (!result.isConfirmed) return;
      try {
        const res = await axios.delete(`/whatsapp/groups/${row.group.id}`);
        if (res.data.status) {
          Swal.fire({ icon: 'success', title: 'تم', text: 'تم إلغاء ربط المجموعة بنجاح', timer: 1500, showConfirmButton: false });
          await this.fetchYears();
        }
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'خطأ', text: e.response?.data?.message || 'حدث خطأ' });
      }
    },

    // ── Send ──────────────────────────────────────────────────────────────────
    openSend(row) {
      this.sendTarget = row;
      this.sendMessage = '';
      this.showSend = true;
    },
    async submitSend() {
      if (!this.sendMessage.trim()) {
        Swal.fire({ icon: 'warning', title: 'تنبيه', text: 'يرجى كتابة الرسالة' });
        return;
      }
      this.sending = true;
      try {
        const res = await axios.post('/whatsapp/groups/send', {
          academic_year_id: this.sendTarget.academic_year_id,
          message: this.sendMessage,
        });
        if (res.data.status) {
          this.showSend = false;
          Swal.fire({ icon: 'success', title: 'تم الإرسال', text: 'تم إرسال الرسالة إلى المجموعة بنجاح', timer: 1500, showConfirmButton: false });
        } else {
          Swal.fire({ icon: 'error', title: 'خطأ', text: res.data.message || 'فشل إرسال الرسالة' });
        }
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'خطأ', text: e.response?.data?.message || 'حدث خطأ غير متوقع' });
      } finally {
        this.sending = false;
      }
    },

    // ── Helpers ───────────────────────────────────────────────────────────────
    availableGroupName(g)  { return g.name  ?? g.subject ?? 'مجموعة'; },
    availableGroupJid(g)   { return g.jid   ?? g.id      ?? g.gid    ?? ''; },
    availableGroupCount(g) { return g.participantsCount ?? g.participants_count ?? '—'; },

    formatDate(d) {
      if (!d) return '—';
      return new Date(d).toLocaleDateString('ar-EG', { year: 'numeric', month: 'short', day: 'numeric' });
    },
  },
  mounted() {
    this.fetchYears();
  },
};
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">

    <!-- Page Header -->
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-users"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">مجموعات واتساب</h1>
        <p class="form-page-header__subtitle">إدارة مجموعات واتساب المرتبطة بالمراحل الدراسية</p>
      </div>
      <button type="button" class="btn btn-outline-secondary btn-sm ms-auto" @click="fetchYears" :disabled="loading">
        <i class="pi" :class="loading ? 'pi-spin pi-spinner-dotted' : 'pi-refresh'"></i>
        تحديث
      </button>
    </div>

    <div class="container-fluid">
      <div class="form-card">
        <div class="form-card__header">
          <div class="form-card__header-icon"><i class="pi pi-whatsapp"></i></div>
          <div>
            <span class="form-card__title">ربط مجموعات واتساب</span>
            <p class="form-card__subtitle">كل مرحلة دراسية يمكن ربطها بمجموعة واتساب واحدة</p>
          </div>
        </div>
        <div class="form-card__body p-0">

          <!-- Loading -->
          <div v-if="loading" class="text-center py-5">
            <i class="pi pi-spin pi-spinner-dotted" style="font-size: 2rem; color: #25d366;"></i>
            <p class="mt-2 text-muted">جاري التحميل...</p>
          </div>

          <!-- Table -->
          <div v-else class="table-responsive">
            <table class="table table-striped wa-groups-table mb-0">
              <thead>
                <tr>
                  <th>المرحلة الدراسية</th>
                  <th>عدد الطلاب</th>
                  <th>اسم المجموعة</th>
                  <th>المشتركون</th>
                  <th>آخر تحديث</th>
                  <th>الإجراءات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in years" :key="row.academic_year_id">

                  <td data-label="المرحلة الدراسية">
                    <span class="fw-bold">{{ row.year_title }}</span>
                  </td>

                  <td data-label="عدد الطلاب">
                    <span class="badge bg-primary-subtle text-primary px-2 py-1 rounded-pill">
                      <i class="pi pi-users me-1"></i>{{ row.students_count }}
                    </span>
                  </td>

                  <td data-label="اسم المجموعة">
                    <span v-if="row.group" class="badge-group">
                      <i class="pi pi-whatsapp me-1"></i>{{ row.group.group_name }}
                    </span>
                    <span v-else class="text-muted small">غير مرتبطة</span>
                  </td>

                  <td data-label="المشتركون">
                    <span v-if="row.group" class="badge bg-success-subtle text-success px-2 py-1 rounded-pill">
                      {{ row.group.participants_count }}
                    </span>
                    <span v-else class="text-muted">—</span>
                  </td>

                  <td data-label="آخر تحديث">
                    <span class="text-muted small">{{ row.group ? formatDate(row.group.updated_at) : '—' }}</span>
                  </td>

                  <td data-label="الإجراءات">
                    <div class="d-flex flex-wrap gap-1">
                      <template v-if="!row.group">
                        <button class="btn btn-sm btn-wa-create" @click="openCreate(row)">
                          <i class="pi pi-plus-circle"></i> إنشاء
                        </button>
                        <button class="btn btn-sm btn-wa-link" @click="openLink(row, false)">
                          <i class="pi pi-link"></i> ربط
                        </button>
                      </template>
                      <template v-else>
                        <button class="btn btn-sm btn-wa-send" @click="openSend(row)">
                          <i class="pi pi-send"></i> إرسال
                        </button>
                        <button class="btn btn-sm btn-wa-change" @click="openLink(row, true)">
                          <i class="pi pi-sync"></i> تغيير
                        </button>
                        <button class="btn btn-sm btn-wa-unlink" @click="unlinkGroup(row)">
                          <i class="pi pi-times-circle"></i> إلغاء
                        </button>
                      </template>
                    </div>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

  </div>

  <!-- ══════════════════════ Create Group Dialog ══════════════════════ -->
  <Dialog v-model:visible="showCreate" modal header="إنشاء مجموعة واتساب جديدة" :style="{ width: '30rem' }" :dismissableMask="true">
    <div class="row g-3">

      <div class="col-12">
        <div class="wa-dialog-info">
          <i class="pi pi-users text-primary me-2"></i>
          <div>
            <div>المرحلة: <strong>{{ createTarget?.year_title }}</strong></div>
            <div class="text-muted small mt-1">
              <i class="pi pi-user me-1"></i>{{ createTarget?.students_count }} طالب مقبول سيتم إضافته تلقائياً
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <label class="form-label">اسم المجموعة <span class="text-danger">*</span></label>
        <InputText v-model="createName" class="w-100" placeholder="مثال: مجموعة ثالثة إعدادي 2025" maxlength="100" />
      </div>

      <div class="col-12 pt-2">
        <button class="btn btn-wa-primary w-100" @click="submitCreate" :disabled="creating || !createName.trim()">
          <i class="pi" :class="creating ? 'pi-spin pi-spinner-dotted' : 'pi-whatsapp'"></i>
          {{ creating ? 'جاري الإنشاء...' : 'إنشاء المجموعة' }}
        </button>
      </div>

    </div>
  </Dialog>

  <!-- ══════════════════════ Link / Change Dialog ══════════════════════ -->
  <Dialog v-model:visible="showLink" modal
    :header="linkTarget?.is_change ? 'تغيير المجموعة المرتبطة' : 'ربط مجموعة موجودة'"
    :style="{ width: '38rem' }" :dismissableMask="true">
    <div class="row g-3">

      <div class="col-12">
        <div class="wa-dialog-info">
          <i class="pi pi-info-circle text-primary me-2"></i>
          المرحلة: <strong class="me-2">{{ linkTarget?.year_title }}</strong>
        </div>
      </div>

      <div v-if="loadingAvailable" class="col-12 text-center py-3">
        <i class="pi pi-spin pi-spinner-dotted" style="font-size:1.5rem;color:#25d366;"></i>
        <p class="text-muted small mt-1">جاري تحميل المجموعات...</p>
      </div>

      <div v-else-if="availableGroups.length === 0" class="col-12 text-center py-3">
        <i class="pi pi-inbox" style="font-size:2rem;color:#ccc;"></i>
        <p class="text-muted mt-1">لا توجد مجموعات على هذا الحساب</p>
      </div>

      <div v-else class="col-12">
        <label class="form-label mb-2">اختر مجموعة</label>
        <div class="wa-group-list">
          <div v-for="(g, i) in availableGroups" :key="i"
            class="wa-group-item" :class="{ 'wa-group-item--selected': selectedAvailable === g }"
            @click="selectedAvailable = g">
            <div class="wa-group-item__radio">
              <i class="pi" :class="selectedAvailable === g ? 'pi-circle-fill text-success' : 'pi-circle'"></i>
            </div>
            <div class="wa-group-item__info">
              <span class="wa-group-item__name">{{ availableGroupName(g) }}</span>
              <span class="wa-group-item__jid">{{ availableGroupJid(g) }}</span>
            </div>
            <div class="wa-group-item__count">
              <i class="pi pi-users"></i> {{ availableGroupCount(g) }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 pt-1" v-if="!loadingAvailable && availableGroups.length > 0">
        <button class="btn btn-wa-primary w-100" @click="submitLink" :disabled="linking || !selectedAvailable">
          <i class="pi" :class="linking ? 'pi-spin pi-spinner-dotted' : 'pi-link'"></i>
          {{ linking ? 'جاري الربط...' : (linkTarget?.is_change ? 'تغيير المجموعة' : 'ربط المجموعة') }}
        </button>
      </div>

    </div>
  </Dialog>

  <!-- ══════════════════════ Send Message Dialog ══════════════════════ -->
  <Dialog v-model:visible="showSend" modal header="إرسال رسالة للمجموعة" :style="{ width: '32rem' }" :dismissableMask="true">
    <div class="row g-3">

      <div class="col-12">
        <div class="wa-dialog-info">
          <i class="pi pi-whatsapp text-success me-2"></i>
          <div>
            <div><strong>{{ sendTarget?.group?.group_name }}</strong></div>
            <div class="text-muted small">
              {{ sendTarget?.year_title }}
              &nbsp;·&nbsp;
              <i class="pi pi-users me-1"></i>{{ sendTarget?.group?.participants_count }} مشترك
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <label class="form-label">الرسالة <span class="text-danger">*</span></label>
        <textarea v-model="sendMessage" class="form-control" rows="5"
          placeholder="اكتب رسالتك هنا..." maxlength="4000"></textarea>
        <div class="text-end mt-1">
          <span :class="sendMessage.length > 3500 ? 'text-danger' : 'text-muted'" class="small">
            {{ sendMessage.length }} / 4000
          </span>
        </div>
      </div>

      <div class="col-12 pt-1">
        <button class="btn btn-wa-primary w-100" @click="submitSend" :disabled="sending || !sendMessage.trim()">
          <i class="pi" :class="sending ? 'pi-spin pi-spinner-dotted' : 'pi-send'"></i>
          {{ sending ? 'جاري الإرسال...' : 'إرسال للمجموعة' }}
        </button>
      </div>

    </div>
  </Dialog>

</template>

<style scoped>
.wa-groups-table th { background: #f8f9fa; font-weight: 600; white-space: nowrap; }
.wa-groups-table td { vertical-align: middle; }

.badge-group {
  display: inline-flex; align-items: center;
  background: #e8f5e9; color: #2e7d32;
  padding: 3px 10px; border-radius: 20px;
  font-size: .85rem; font-weight: 500;
}

.btn-wa-create  { background:#e3f2fd; color:#1565c0; border:1px solid #90caf9; }
.btn-wa-link    { background:#f3e5f5; color:#6a1b9a; border:1px solid #ce93d8; }
.btn-wa-send    { background:#e8f5e9; color:#2e7d32; border:1px solid #a5d6a7; }
.btn-wa-change  { background:#fff3e0; color:#e65100; border:1px solid #ffcc80; }
.btn-wa-unlink  { background:#fce4ec; color:#b71c1c; border:1px solid #f48fb1; }
.btn-wa-primary { background:#25d366; color:#fff; border:none; font-weight:600; }

.btn-wa-create:hover  { background:#bbdefb; }
.btn-wa-link:hover    { background:#e1bee7; }
.btn-wa-send:hover    { background:#c8e6c9; }
.btn-wa-change:hover  { background:#ffe0b2; }
.btn-wa-unlink:hover  { background:#f8bbd0; }
.btn-wa-primary:hover { background:#1ebe57; }

.wa-dialog-info {
  display:flex; align-items:flex-start;
  background:#f8f9fa; border-radius:8px;
  padding:10px 14px; font-size:.9rem;
}

.wa-group-list {
  max-height:260px; overflow-y:auto;
  border:1px solid #dee2e6; border-radius:8px;
}

.wa-group-item {
  display:flex; align-items:center; gap:12px;
  padding:10px 14px; cursor:pointer;
  border-bottom:1px solid #f0f0f0; transition:background .15s;
}
.wa-group-item:last-child { border-bottom:none; }
.wa-group-item:hover { background:#f5f5f5; }
.wa-group-item--selected { background:#e8f5e9 !important; }

.wa-group-item__radio  { flex-shrink:0; font-size:1.1rem; }
.wa-group-item__info   { flex:1; display:flex; flex-direction:column; min-width:0; }
.wa-group-item__name   { font-weight:600; font-size:.9rem; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.wa-group-item__jid    { font-size:.75rem; color:#999; direction:ltr; text-align:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.wa-group-item__count  { flex-shrink:0; font-size:.8rem; color:#666; display:flex; align-items:center; gap:4px; }
</style>
